// src/pages/performanceanalysis/tabs.ts
// Slug, label and order for the Performance Analysis tab row.
//
// Its own module rather than part of the page: routes.tsx needs the slugs to
// declare the child routes, and importing them from the page component would
// pull it out of its React.lazy chunk and into the main bundle.
//
// The slugs are a URL contract — they appear in shared and bookmarked links
// (/performance-analysis/grids?propertyId=…), so renaming one breaks those.

export const PERFORMANCE_ANALYSIS_TABS = [
  { slug: "monthly_analysis", label: "Monthly Analysis" },
  { slug: "daily_snapshot", label: "Daily Snapshot" },
  { slug: "grids", label: "Grids" },
] as const;

export type PerformanceAnalysisTabSlug =
  (typeof PERFORMANCE_ANALYSIS_TABS)[number]["slug"];

export const DEFAULT_PERFORMANCE_ANALYSIS_TAB: PerformanceAnalysisTabSlug =
  "monthly_analysis";

export const PERFORMANCE_ANALYSIS_PATH = "/performance-analysis";

export const tabPath = (slug: PerformanceAnalysisTabSlug): string =>
  `${PERFORMANCE_ANALYSIS_PATH}/${slug}`;
